module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin12-f0a24a5306dea2dcbe9ca5a65164d785.jpg";